import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=bfa44068&"
import script from "./orderRefund.vue?vue&type=script&lang=js&"
export * from "./orderRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports